// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#awsccc-sb-ux-c #awsccc-sb-a #awsccc-cs-info-container span,#awsccc-sb-ux-c #awsccc-sb-a #awsccc-cs-info-container a{font-size:15px}", ""]);
// Exports
module.exports = exports;
